import { useReducer } from 'react';

const initialState = {
  contrastValue: 100,
  fontColor: 'hsl(0, 0%, 100%)',
};

const contrastSensitivityReducer = (existingData, action) => {
  switch (action.type) {
    case 'setContrastValue':
      return { ...existingData, contrastValue: action.payload };
    case 'setFontColor':
      return { ...existingData, fontColor: action.payload };
    default:
      return existingData;
  }
};

export const useContrastSensitivityData = () => {
  const [currentContrastSensitivityData, updateContrastSensitivityData] = useReducer(contrastSensitivityReducer, initialState);
  return { currentContrastSensitivityData, updateContrastSensitivityData };
};
